import {observer} from 'mobx-react';
import React from 'react';
import {X9Content, X9ContentSnapshot} from '../../../../../domain';
import {X9ContentViewHeaders} from '../../common/X9ContentViewHeaders';
import {X9ContentViewStore} from '../../common/X9ContentViewStore';
import {StudentGapFilling} from '../classroom/student/StudentGapFilling';
import {TeacherGapFilling} from '../classroom/teacher/TeacherGapFilling';

@observer
export class GapFillingView extends React.Component<{ x9: X9Content | X9ContentSnapshot }> {
  readonly store: X9ContentViewStore;

  constructor(props: Readonly<{ x9: X9Content | X9ContentSnapshot }>) {
    super(props);
    this.store = new X9ContentViewStore(props.x9);
  }

  render() {
    const store = this.store;
    const role = store.role.value;
    const x9 = this.props.x9;

    return (<>
      <X9ContentViewHeaders store={store}/>
      {
        role === 'Student' &&
        <StudentGapFilling x9={x9} store={store}/>
      }
      {
        role === 'Teacher' &&
        <TeacherGapFilling x9={x9} store={store}/>
      }
    </>);
  }
}
